import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { Plus } from "lucide-mui";
import { useState } from "react";
import EmptyState from "../EmptyState.tsx";
import TenantDialog from "../TenantDialog.tsx";
import { useOrganization } from "../../contexts/OrganizationContext.tsx";

export default function EmptyTenantPrompt() {
  const { currentOrg } = useOrganization();
  const [dialogOpen, setDialogOpen] = useState(false);

  // Bootstrapping an org's very first tenant is allowed for any member, not
  // just org admins — mirrors the backend relaxation in POST /tenants (an
  // org stuck at zero tenants has no other way out for a plain member).
  const canCreate = !!currentOrg;

  return (
    <>
      <EmptyState
        variant="panel"
        title="No workspace yet"
        description={
          <>
            A tenant is your team's workspace — think of it like a project where you gather the
            companies, collections, and data for a specific initiative. Your account isn't in one
            yet, so there's nothing to show here.
            {!canCreate && <Box sx={{ mt: 2 }}>Ask your organization admin to set one up for you.</Box>}
          </>
        }
        action={
          canCreate && (
            <Button variant="contained" startIcon={<Plus />} onClick={() => setDialogOpen(true)}>
              Create your first tenant
            </Button>
          )
        }
      />
      {currentOrg && dialogOpen && (
        <TenantDialog onClose={() => setDialogOpen(false)} organizationId={currentOrg.id} />
      )}
    </>
  );
}
